/**
 * Get the value of the cookie, does the same as the cookieStore, but does not change the return type
 * @param {string} name - Cookie name
 * @return {string | undefined} Cookie value
 */
export const getCookie = (name: string) => {
    const matches = document.cookie.match(
        new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`),
    );
    // eslint-disable-next-line no-undefined
    return matches ? decodeURIComponent(matches[1]) : undefined;
};
